import { render, staticRenderFns } from "./AdminDomainForm.vue?vue&type=template&id=b2d36d4a&scoped=true"
import script from "./AdminDomainForm.vue?vue&type=script&lang=ts"
export * from "./AdminDomainForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminDomainForm.vue?vue&type=style&index=0&id=b2d36d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d36d4a",
  null
  
)

export default component.exports